module.exports = __webpack_public_path__ + "static/media/edge-logo.b0aae716.svg";